import Grid from '@gogame/ui/Grid';
import Toolbar from '@gogame/ui/Toolbar';
import Typography from '@gogame/ui/Typography';
import View from '@gogame/ui/View';
import { makeStyles } from '@gogame/ui/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    height: 'auto',
    borderRadius: '4px',
  },
  toolbar: {
    alignItems: 'stretch',
    flexDirection: 'column',
    padding: '12px 16px',
  },
  content: {
    flexGrow: '1',
    display: 'flex',
    padding: '0px 16px',
    minHeight: ({ minContentHeight }) => minContentHeight,
  },
}));

export const ChartContainer = ({
  children,
  title,
  affix = null,
  loading,
  loaderType,
  actions = null,
  sidebar = null,
  hiddenToolbar,
  minContentHeight,
  style,
  settingsPreview = null,
}) => {
  const classes = useStyles({ minContentHeight });
  return (
    <View loading={loaderType === 'container' ? loading : undefined}>
      <div className={classes.root} style={style}>
        <Grid container direction={'column'}>
          {!hiddenToolbar ? (
            <Toolbar
              data-cy={'chartToolbar'}
              className={classes.toolbar}
              disableGutters={true}
            >
              <Grid container>
                <Grid
                  container
                  item
                  xs
                  alignItems={'center'}
                  data-cy={'chart-affix'}
                >
                  {title ? (
                    <Typography variant={'subtitle1'}>{title}</Typography>
                  ) : null}
                  {affix}
                </Grid>
                <Grid
                  container
                  item
                  xs
                  justifyContent={'flex-end'}
                  alignItems={'center'}
                  data-cy={'chart-actions'}
                >
                  {actions}
                </Grid>
              </Grid>
              <Grid
                container
                justifyContent={'flex-end'}
                data-cy={'chart-settings-preview'}
              >
                {settingsPreview}
              </Grid>
            </Toolbar>
          ) : null}
          <Grid item container style={{ flexGrow: 1 }}>
            <View
              loading={loaderType === 'chart' ? loading : undefined}
              className={classes.content}
            >
              {children}
            </View>
          </Grid>
        </Grid>
        {sidebar}
      </div>
    </View>
  );
};

export default ChartContainer;
